import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import user_profile from '../assets/images/user_profile.svg';
import up_arrow_green from '../assets/images/up_arrow_yellow.svg';
import up_arrow_yellow from '../assets/images/up_arrow_green.svg';
import aadhar from '../assets/images/aadhar_fb.svg';
import pan from '../assets/images/pan_card.svg';
import qualification from '../assets/images/qualification.svg';
import cheque from '../assets/images/cheque.svg';
import photograph from '../assets/images/photograph.svg';
import { InstanceWithAuth, USER_PROFILE, LEAD_KPI } from 'api/routes';

export const UserProfile = () => {
  const [userData, setUserData] = useState([]);
  const [kpis, setKpis] = useState([]);

  const idvfun = async () => {
    await InstanceWithAuth.get(USER_PROFILE)
      .then((res) => {
        setUserData(res.data);
        sessionStorage.setItem('userData', JSON.stringify(res.data));
      })
      .catch((err) => {
        console.error(err);
      });

    await InstanceWithAuth.get(LEAD_KPI)
      .then((res) => {
        setKpis(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    idvfun();
  }, []);

  const userDetails = sessionStorage.getItem('userprofile');
  const storedObject = JSON.parse(userDetails);

  const profileDetail = {
    img: userData.photo,
    name: `${userData.first_name}  ${userData.last_name}`,
    loc: `PoS - ${userData.region}`,
    total: kpis.total,
    current: kpis.current,
    leads: kpis.lead,
    details: [
      { name: 'PMA No', content: userData.pma_code },
      { name: 'Email', content: userData.email },
      { name: 'RM', content: userData.rm_id },
      {
        name: 'Address',
        content: userData.address,
      },
      { name: 'Region', content: userData.region },
      { name: 'Mobile Number', content: userData.mobile_no },
    ],
    documents: [
      { img: aadhar, name: 'Aadhar Card (Front)', link: userData.aadhar_front },
      { img: aadhar, name: 'Aadhar Card (Back)', link: userData.aadhar_back },
      { img: pan, name: 'PAN Card', link: userData.pan },
      { img: cheque, name: 'Cheque', link: userData.cheque },
      {
        img: qualification,
        name: 'Qualification',
        link: userData.qualification,
      },
      { img: photograph, name: 'Photograph', link: userData.photo },
    ],
  };
  return (
    <div className="my-20">
      <div
        // style={{boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px"}}
        className="mx-20 py-5 px-4 shadow-md rounded-md flex flex-col md:flex-row gap-10 bg-white"
      >
        <div className="flex  flex-col gap-10 sm:justify-around items-center md:flex-row md:w-1/2">
          <div className="flex flex-col gap-4 sm:flex-row lg:flex-col items-center justify-between">
            <div className="rounded-full">
              <img
                src={profileDetail.img}
                alt="user_profile"
                className="rounded-full w-24 h-24 "
              />
            </div>
            <div>
              <p className="text-lg font-semibold w-max">
                {profileDetail.name}
              </p>
            </div>
            <div className="bg-sky-200 rounded-md">
              <p
                style={{
                  color: '#16C098',
                  fontSize: '14px',
                  fontWeight: '700',
                  textTransform: 'capitalize',
                }}
                className="px-5 py-1 w-max"
              >
                {profileDetail.loc}
              </p>
            </div>
          </div>
          <div className="flex gap-10 items-center ">
            <div className="grid w-20 h-max p-2 place-content-center place-items-center border border-gray-100 border-dashed rounded-md">
              <div className="flex justify-center gap-1">
                <p className="font-semibold text-2xl">{profileDetail.total}</p>
                <img src={up_arrow_green} alt="up" />
              </div>
              <p>Total</p>
            </div>
            <div className="grid w-20  h-max p-2 place-content-center border border-gray-100 border-dashed rounded-md">
              <div className="flex justify-center gap-1">
                <p className="font-semibold text-xl">{profileDetail.current}</p>
                <img src={up_arrow_green} alt="up" />
              </div>
              <p>Current</p>
            </div>
            <div className="grid w-20  h-max p-2 place-content-center border border-gray-100 border-dashed rounded-md">
              <div className="flex justify-center gap-1">
                <p className="font-semibold text-xl">{profileDetail.leads}</p>
                <img src={up_arrow_yellow} alt="up" />
              </div>
              <p>Leads</p>
            </div>
          </div>
        </div>
        <div className="px-10 grid gap-4 items-center sm:grid-cols-2">
          {profileDetail.details.map((el, i) => {
            return (
              <div key={i}>
                <p className="font-bold text-sm">{el.name}</p>
                <p
                  className="font-normal text-sm "
                  style={{ textTransform: 'capitalize' }}
                >
                  {el.content}
                </p>
              </div>
            );
          })}
        </div>
        <div></div>
      </div>
      <div className="mx-20 my-20">
        <p className="text-2xl font-bold">Documents</p>
        <div className="grid place-content-center w-full">
          <div className="py-20 grid sm:grid-cols-3 gap-24">
            {profileDetail.documents.map((el, i) => {
              return (
                <div key={i} className="flex flex-col justify-between">
                  <a href={el.link} rel="noreferrer" target="_blank">
                    <img
                      className="self-center mb-1"
                      src={el.img}
                      alt={el.name}
                    />
                  </a>
                  <p className="self-center font-semibold text-sm">{el.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
